import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const modernTreasury = defineConnector({
  identifier: "modernTreasury",
  name: "Modern Treasury",
  tagLine: "Payment operations platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://app\\.moderntreasury\\.com/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.organizationId,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Modern Treasury](https://app.moderntreasury.com/developers/api-keys), open **Developers › API Keys** and copy your organization ID and an API key.",
        },
      ],
    },
    {
      title: "Enter your Modern Treasury details",
      items: [
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "organizationId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.moderntreasury.com/api/ping",
  },
});
